export default __webpack_public_path__ + "static/news-img-default-5772eb9dccdc5006be4fb6966f8158a4.jpg";